/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface WebAuthnCreateAttestation
 */
export interface WebAuthnCreateAttestation {
    /**
     * 
     * @type {string}
     * @memberof WebAuthnCreateAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof WebAuthnCreateAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {object}
     * @memberof WebAuthnCreateAttestation
     */
    data?: object;
}

/**
 * Check if a given object implements the WebAuthnCreateAttestation interface.
 */
export function instanceOfWebAuthnCreateAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function WebAuthnCreateAttestationFromJSON(json: any): WebAuthnCreateAttestation {
    return WebAuthnCreateAttestationFromJSONTyped(json, false);
}

export function WebAuthnCreateAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnCreateAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function WebAuthnCreateAttestationToJSON(value?: WebAuthnCreateAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
        'data': value.data,
    };
}

